import { ComponentClassNames } from '../../util/classNames';
import { getGutterValue } from '../../util/styles/gutters';
import { getPaddingStyles } from '../../util/styles/padding';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

import { FlexProps } from './Flex.types';

type FlexClassNames = ComponentClassNames<'flex'>;
type FlexClassNameProps = Omit<FlexProps, 'ariaHidden'>;
type GetFlexClassNames = (props: FlexClassNameProps) => FlexClassNames;

export const getClassNames: GetFlexClassNames = memoizeFunction(
  ({
    alignItems,
    display = 'flex',
    direction: flexDirection,
    justifyContent,
    wrap: flexWrap,
    columnGap = 0,
    rowGap = 0,
    height,
    minHeight,
    maxHeight,
    width,
    minWidth,
    maxWidth,
    className,

    // FlexItem styles
    basis: flexBasis,
    grow: flexGrow,
    shrink: flexShrink,
    alignSelf,
    order,

    ...paddingProps
  }) =>
    mergeStyleSets({
      flex: [
        {
          alignItems,
          display,
          flexDirection,
          flexWrap,
          justifyContent,
          height,
          minHeight,
          maxHeight,
          width,
          minWidth,
          maxWidth,
          columnGap: getGutterValue(columnGap),
          rowGap: getGutterValue(rowGap),
          ...getPaddingStyles(paddingProps),

          flexBasis,
          flexGrow,
          flexShrink,
          alignSelf,
          order,

          /**
           * Allows text ellipsis to work for all children of <Flex>, even if not wrapped in a <FlexItem> component.
           * https://css-tricks.com/flexbox-truncated-text/
           */
          '> *': {
            minWidth: 0,
          },
        },
        className,
      ],
    })
);
